import { observer } from 'mobx-react-lite'
import { Button, EmptyState, Typography } from 'shared/ui'
import { LINK_TEAMS_GUIDE } from 'shared/constants/links'
import teamsPreviewImg from 'shared/assets/images/teams/teams_preview.png'
import { getCDNAssetURL } from 'shared/lib'
import { useTeamsContext } from 'pages/settings/pages/teams/context/teamsContext'
import { ImportFromHubSpotDropdown } from 'pages/settings/pages/teams/ui/ImportFromHubSpotDropdown'

import styles from './styles.module.scss'

export const TeamsEmpty = observer(() => {
  const teamsStore = useTeamsContext()

  return (
    <section className={styles.empty}>
      <EmptyState
        title={
          <span className={styles.title}>
            <a
              href={LINK_TEAMS_GUIDE}
              rel='noreferrer'
              target='_blank'
              className={styles.titlePreview}
            >
              <img alt='Teams preview' src={getCDNAssetURL(teamsPreviewImg)} />
            </a>
            <Typography variant={'heading-lg'} ariaLabel='Create your first team'>
              Create your first team
            </Typography>
          </span>
        }
        actions={
          <div className={styles.actions}>
            <Button
              text='New team'
              size='medium'
              iconProps={{ icon: 'add' }}
              className={styles.createButton}
              onClick={teamsStore.navigateToCreateTeam}
            />
            <ImportFromHubSpotDropdown
              teamsStore={teamsStore}
              className={styles.importButton}
              dropdownProps={{
                placement: 'top-start',
              }}
            />
          </div>
        }
        text={
          <>
            Organize members into teams to manage conversations, and control
            <br />
            visibility as you scale.{' '}
            <Typography key={'link'} variant={'body-lg-regular'} linkLight ariaLabel={'LearnMore'}>
              <a href={LINK_TEAMS_GUIDE} target={'_blank'} rel='noreferrer'>
                Learn more
              </a>
            </Typography>
          </>
        }
        typographyProps={{
          variant: 'body-lg-regular',
          ariaLabel: 'KnowledgeBaseText',
          marginTop: '4px',
        }}
        boxProps={{
          gap: '20px',
          width: 'unset',
          height: 'unset',
          textAlign: 'center',
        }}
        noIcon
      />
    </section>
  )
})
